
const CHANNEL_NAME = 'auth_channel';
export const authChannel = new BroadcastChannel(CHANNEL_NAME)

export type AuthMessage =
    | { type: 'LOGOUT' }